import { makeStyles } from '@material-ui/core/styles';
import BorderAllIcon from '@material-ui/icons/BorderAll';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FlareIcon from '@material-ui/icons/Flare';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import OpenWithIcon from '@material-ui/icons/OpenWith';
import SignalWifi4BarIcon from '@material-ui/icons/SignalWifi4Bar';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import { switchUtil } from '@timeflies/common';
import React from 'react';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: function (_a) {
            var variableName = _a.variableName;
            return ({
                color: palette.variables[variableName]
            });
        }
    });
});
var NoopComponent = function () { return null; };
export var VariableIcon = function (props) {
    var classes = useStyles(props);
    var Component = switchUtil(props.variableName, {
        // character
        health: function () { return FavoriteIcon; },
        actionTime: function () { return HourglassFullIcon; },
        position: function () { return OpenWithIcon; },
        orientation: function () { return ZoomOutMapIcon; },
        // spell
        duration: function () { return HourglassFullIcon; },
        rangeArea: function () { return SignalWifi4BarIcon; },
        actionArea: function () { return BorderAllIcon; },
        lineOfSight: function () { return NoopComponent; },
        attack: function () { return FlareIcon; },
    })();
    return React.createElement(Component, { className: classes.root, fontSize: 'inherit' });
};
